import Dce from "dce-engine/lib/decorators/Dce";
import DceComponent from "dce-engine/lib/engine/DceComponent";
import DceHTMLElement from "dce-engine/lib/types/DceHTMLElement";
import {Logger} from "dce-logger";


interface ConfirmDialogProps {
}

@Dce("ConfirmDialog")
export default class ConfirmDialog extends DceComponent<ConfirmDialogProps> {

    constructor(elem: DceHTMLElement, props: ConfirmDialogProps) {
        super(elem, props);
    }

    public close(){
        this.elem.classList.remove("active");
    }

}
